import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { ko } from '@/i18n/ko';

export function PublicShamanPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data, isLoading, error } = useQuery({
    queryKey: ['public-shaman', slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('public_shamans')
        .select('slug, display_name_ko, bio, is_bookable')
        .eq('slug', slug)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });

  if (isLoading) return <div className="text-center py-12 text-ink-muted">{ko.common.loading}</div>;
  if (error || !data) {
    return (
      <div className="card text-center space-y-3">
        <h1 className="text-xl font-bold">페이지를 찾을 수 없어요</h1>
        <p className="text-ink-muted">주소를 다시 확인해주세요.</p>
      </div>
    );
  }

  if (!data.is_bookable) {
    return (
      <div className="card text-center space-y-3">
        <h1 className="text-xl font-bold">{data.display_name_ko}</h1>
        <p className="text-ink-muted">{ko.booking.bookingClosed}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="card space-y-2">
        <h1 className="text-2xl font-bold">{data.display_name_ko}</h1>
        {data.bio && <p className="text-base leading-relaxed whitespace-pre-line">{data.bio}</p>}
      </div>
      <Link to={`/book/${data.slug}`} className="btn-primary w-full">
        예약하기
      </Link>
    </div>
  );
}
